import styles from './Logo.module.css';
import type { FC } from 'react';
import type { LogoProps } from './Logo.types';
import { LogoFull } from './components/LogoFull';
import { LogoEmblem } from './components/LogoEmblem';

export const Logo: FC<LogoProps> = ({ size = 32, isEmblem }) => {
  const LogoComponent = isEmblem ? LogoEmblem : LogoFull;

  return (
    <div
      data-component="Logo"
      style={{ height: `${size}px` }}
      className={styles.logo}
    >
      <LogoComponent />
    </div>
  );
};
